import { useTranslation } from 'react-i18next';
import Navbar from '../home/components/Navbar';
import FAQ from '../home/components/FAQ';
import Footer from '../home/components/Footer';
import PageHero from '../../components/feature/PageHero';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://fmacrew.com';

const FAQ_HERO_IMAGE = "https://public.readdy.ai/ai/img_res/976c4de6c8392b31f91125fecb3d815d.jpg";

export default function FAQPage() {
  const { t } = useTranslation();
  return (
    <>
      <title>FAQ | FMA Crew — Apartment Maintenance & Remodeling Atlanta GA</title>
      <meta
        name="description"
        content="Frequently asked questions about FMA Crew's apartment maintenance, residential remodeling, and commercial remodeling services across Greater Atlanta, GA."
      />
      <link rel="canonical" href={`${SITE_URL}/faq`} />
      <main className="min-h-screen bg-white">
        <Navbar />
        <PageHero
          title={t('faq.hero.title')}
          titleEm={t('faq.hero.titleEm')}
          image={FAQ_HERO_IMAGE}
        />
        <FAQ />
        <Footer />
      </main>
    </>
  );
}